export default __webpack_public_path__ + "4e21e904236309b950880fab89bd4e56.svg";